// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"de\":{\"assignments\":{\"date_due_column_view\":{\"due\":\"Fällig\",\"due_date\":\"Fällig\",\"multiple_dates\":\"Mehrere Daten\",\"todo_date\":\"Zu erledigen\"}}},\"hu\":{\"assignments\":{\"date_due_column_view\":{\"due\":\"Határidő\",\"due_date\":\"Határidő\",\"multiple_dates\":\"Többes határidő\"}}}}"));
